const groupFinTermsViewActions = {
  GROUP_FIN_TERMS_VIEW_INIT: 'GROUP_FIN_TERMS_VIEW_INIT',
  GROUP_FIN_TERMS_VIEW_SET: 'GROUP_FIN_TERMS_VIEW_SET'
};
export default groupFinTermsViewActions;
